import { useRouteLoaderData } from 'react-router'

import { AmplitudeData, AppLoaderData, PendoData } from '~/types/app'
import { SWAGGERHUB_ROLE } from '~/types/portal'
import { UserInfo } from '~/types/user'

export const useUser = (): { user?: UserInfo; isLoggedIn: boolean; pendoData?: PendoData; amplitudeData?: AmplitudeData, organizationRole?: SWAGGERHUB_ROLE } => {
  const data = useRouteLoaderData<AppLoaderData>('root')
  const user = data?.user
  const pendoData = data?.pendoData
  const amplitudeData = data?.amplitudeData
  const isLoggedIn = Boolean(user?.email)
  const organizationRole = data?.organizationRole
  return {
    user,
    pendoData,
    amplitudeData,
    isLoggedIn,
    organizationRole,
  }
}